var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[(_vm.loading)?_c('div',{staticClass:"bg"},[_c('animated-logo'),_c('v-progress-linear',{attrs:{"indeterminate":true}})],1):_c('content-viewer',{attrs:{"id":_vm.content_id,"major_revision":_vm.major_revision,"minor_revision":_vm.minor_revision,"view":_vm.view,"mode":"present"},on:{"update:view":function($event){_vm.view=$event}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }